export class ChargeAccountDataEntity {
    chargeAccountName;
    contactFirstName;
    contactLastName;
    isFullValidation;
    discountType;
    amount;
    notes;
    siteId;

    constructor(
        chargeAccountName,
        contactFirstName,
        contactLastName,
        isFullValidation,
        discountType,
        amount,
        notes,
        siteId
      ) {
        this.chargeAccountName = chargeAccountName;
        this.contactFirstName = contactFirstName;
        this.contactLastName = contactLastName;
        this.isFullValidation = isFullValidation;
        this.discountType = discountType;
        this.amount = amount;
        this.notes = notes;
        this.siteId = siteId;
      }
}